import { Select, TextInput } from '@uplift/ui-v2';
import { useProfileStyles } from '../styles';
import { ProfileForm } from './types';

export type EducationFormProps = {
  index?: number;
};


const degreeOptions = [
  "Associate's",
  "Bachelor's",
  "Master's",
  'Doctorate',
];


export const EducationForm: React.VFC<EducationFormProps> = props => {
  const getFieldName = (name: keyof ProfileForm['education']['degrees'][number]) => {
    if (props.index !== undefined) {
      return `degrees[${props.index}].${name}`;
    }

    return name;
  };
  const { classes } = useProfileStyles();

  return (
    <div className={classes.formGroup}>
      <TextInput
        name={getFieldName('school')}
        label="School Name"
        inputClasses={{ root: classes.maxWidth400 }}
      />
      <TextInput
        name={getFieldName('fieldOfStudy')}
        label="Field of study"
        inputClasses={{ root: classes.maxWidth400 }}
      />
      <Select
        items={degreeOptions.map((option) => ({ label: option, value: option }))}
        name={getFieldName('degree')}
        label="Degree"
        inputClasses={{ root: classes.maxWidth220 }}
      />
      <TextInput
        name={getFieldName('yearGraduated')}
        label="Year graduated"
        type="number"
        inputClasses={{ root: classes.maxWidth120 }}
      />
    </div>
  );
};
